import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_83: DocMigration = {
  maxSchemaVersion: "0.0.83",
  description: "Correctly migrate presets",
  apply(json: any) {
    if (!json.presets) {
      return json;
    }

    for (const presetId in json.presets) {
      json.presets[presetId].design = flattenDesign0075(json.presets[presetId].design);
    }

    return json;
  },
};

function flattenDesign0075(design: any) {
  if (design.roomParamValues) {
    for (const roomId in design.roomParamValues) {
      for (const paramId in design.roomParamValues[roomId]) {
        design[paramId + roomId] = design.roomParamValues[roomId][paramId];
      }
    }

    delete design.roomParamValues;
  }

  if (design.partiParamValues) {
    Object.assign(design, design.partiParamValues);
    delete design.partiParamValues;
  }

  return design;
}

export default migration_0_0_83;
